import React from 'react'
import { getConfig } from '../../../resources/configSettings';
import numWords from 'num-words'
import './showInvGST.css'

const ShowInvPatternGST = ({ invoice }) => {
    const { companyName, companyAddress, companyContact, gst, customerName, customerGST, customerDetails, customerContact, invoiceNo, billDate, products, subtotalAmt, gstTotal, totalAmt, saletype } = invoice;
    let Config = getConfig();
    return (
        <div id="page-wrap" className='inv'>
            <h5 id="header">INVOICE</h5>
            <div id="identity">
                <div id="company">
                    <h3> {companyName} </h3>
                    <p> {companyAddress} </p>
                    <p> {companyContact} </p>
                    {Config.gst.enabled && gst ? (<p><b>GSTIN </b>{gst}</p>) : ('')}
                </div>
            </div>

            <div id="customer">
                <p>Bill To :</p>
                <p id="customer-title">{customerName}</p>
                <p>{customerDetails}</p>
                <p>{customerContact}</p>
                {customerGST ? (<p><b>GSTIN</b> {customerGST}</p>) : ('')}
            </div>
            <table id="meta">
                <tr>
                    <td class="meta-head">Invoice #</td>
                    <td><span>{invoiceNo}</span></td>
                </tr>
                <tr>
                    <td class="meta-head">Date</td>
                    <td><span id="date">{billDate}</span></td>
                </tr>
            </table>

            <table id="items">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>HSN</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Amount</th>
                        {saletype === 'intrastate' ? (<>
                            <th colspan='2'>CGST</th>
                            <th colspan='2'>SGST</th>
                        </>) : ('')}
                        {saletype === 'interstate' ? (
                            <th colspan='2'>IGST</th>) : ('')}
                        <th>Total</th>
                    </tr>
                    <tr>
                        <th colspan='6'></th>
                        {saletype === 'intrastate' ? (<>
                            <th>%</th>
                            <th>Amt</th></>) : ('')}
                        <th>%</th>
                        <th>Amt</th>
                        <th></th>
                    </tr>

                </thead>
                <tbody>
                    {products.map((product, i) => (
                        <tr class="item-row" key={product.id}>
                            <td className='sno'>{i + 1}.</td>
                            <td class="item-name">{product.name}</td>
                            <td>{product.hsn ? product.hsn : ''}</td>
                            <td>{product.quantity}</td>
                            <td>{(product.price).toFixed(2)}</td>
                            <td>{(product.amount).toFixed(2)}</td>
                            {saletype === 'intrastate' ? (<>
                                <td>{product.gstr / 2}</td>
                                <td>{(product.gstAmt / 2).toFixed(2)}</td>
                                <td>{product.gstr / 2}</td>
                                <td>{(product.gstAmt / 2).toFixed(2)}</td></>) : ('')}
                            {saletype === 'interstate' ? (<>
                                <td>{product.gstr}</td>
                                <td>{(product.gstAmt).toFixed(2)}</td></>) : ('')}
                            <td>{(product.total).toFixed(2)}</td>
                        </tr>
                    )
                    )}

                    {
                        saletype === 'intrastate' ? (
                            <>
                                <tr class='item-row start'>
                                    <td colSpan="5" style={{ textAlign: 'left' }} className="">Total :  </td>
                                    <td colSpan="1" className="">{(subtotalAmt).toFixed(2)}</td>
                                    <td colSpan="2" >{(gstTotal / 2).toFixed(2)}</td>
                                    <td colSpan="2" >{(gstTotal / 2).toFixed(2)}</td>
                                    <td colSpan="1" >{(totalAmt).toFixed(2)}</td>
                                </tr >
                                <tr className=''>
                                    <td colSpan="7" class="blank"> </td>
                                    <td colSpan="2" class="total-line">SubTotal : </td>
                                    <td colSpan="2" class="total-value"><span id="total">Rs. {(subtotalAmt).toFixed(2)}</span></td>
                                </tr >
                                <tr className=''>
                                    <td colSpan="7" class="blank "></td>
                                    <td colSpan="2" class="total-line">CGST : </td>
                                    <td colSpan="2" class="total-value"><span id="total">Rs. {(gstTotal / 2).toFixed(2)}</span></td>
                                </tr>
                                <tr className=''>
                                    <td colSpan="7" class="blank "></td>
                                    <td colSpan="2" class="total-line">SGST : </td>
                                    <td colSpan="2" class="total-value"><span id="total">Rs. {(gstTotal / 2).toFixed(2)}</span></td>
                                </tr>
                                <tr className=''>
                                    <td colSpan="7" class="blank end text-capital">(in words) {numWords(parseInt(totalAmt))} rupees only</td>
                                    <td colSpan="2" class="total-line">Total</td>
                                    <td colSpan="2" class="total-value"><span id="total">Rs. {totalAmt.toFixed(2)}</span></td>
                                </tr></>

                        ) : ('')
                    }
                    {
                        saletype === 'interstate' ? (
                            <>
                                <tr class='item-row start'>
                                    <td colSpan="5" style={{ textAlign: 'left' }} className="">Total  </td>
                                    <td colSpan="1" className="">{(subtotalAmt).toFixed(2)}</td>
                                    <td colSpan="2" >{(gstTotal).toFixed(2)}</td>
                                    <td colSpan="1" >{(totalAmt).toFixed(2)}</td>
                                </tr >
                                <tr className=''>
                                    <td colSpan="5" class="blank start"> </td>
                                    <td colSpan="2" class="total-line">SubTotal :</td>
                                    <td colSpan="2" class="total-value"><span id="total">Rs. {(subtotalAmt).toFixed(2)}</span></td>
                                </tr >
                                <tr className=''>
                                    <td colSpan="5" class="blank"></td>
                                    <td colSpan="2" class="total-line">IGST :</td>
                                    <td colSpan="2" class="total-value"><span id="total">Rs. {(gstTotal).toFixed(2)}</span></td>
                                </tr>
                                <tr className=''>
                                    <td colSpan="5" class="blank end text-capital">(in words) {numWords(parseInt(totalAmt))} rupees only</td>
                                    <td colSpan="2" class="total-line">Total :</td>
                                    <td colSpan="2" class="total-value"><span id="total">Rs. {totalAmt.toFixed(2)}</span></td>
                                </tr></>
                        ) : ('')
                    }


                </tbody>
            </table>

            <div id="signature">
                <p >For {companyName}</p>
                <p id='sign'>Authorized Signature</p>
            </div>

            <div id="terms">
                <h5>Terms</h5>
                <span>All jurisdiction are subjected to district court.</span>
            </div>

        </div>
    )
}

export default ShowInvPatternGST